import { jsx as p } from "react/jsx-runtime";
import d from "../../ui-kit/theme-button.mjs";
import { useBuyOffer as y } from "../../pages/checkout/api/index.mjs";
import { BadRequest as b } from "@systemeio/util";
import { useStore as w } from "../../store/index.mjs";
import { twJoin as h } from "tailwind-merge";
function S({
  isFetching: r,
  buttonTitle: n,
  setIsFetching: o,
  preSubmit: i,
  handleBadRequest: a,
  hasErrors: f,
  buttonDisabled: s
}) {
  const { locale: m } = w(), { buyOffer: c } = y(), u = async (l) => {
    l.preventDefault(), o(!0);
    try {
      const t = i();
      if (!t) return;
      const { redirect: e } = await c(t, m);
      e && (window.location.href = e);
    } catch (t) {
      if (t instanceof b)
        a(t);
      else
        throw t;
    } finally {
      o(!1);
    }
  };
  return /* @__PURE__ */ p(
    d,
    {
      disabled: s,
      className: h("main-transition-colors", f && "bg-danger focus:bg-danger"),
      onClick: u,
      isFetching: r,
      type: "submit",
      children: n
    }
  );
}
export {
  S as DefaultPaymentButton
};
